import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

interface IllustrationProps {
  sx?: SxProps<Theme>;
}

export const LoginHeroIllustration: React.FC<IllustrationProps> = ({ sx }) => (
  <Box sx={sx}>
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Page */}
      <rect x="25" y="10" width="70" height="100" rx="4" stroke="#c2410c" strokeWidth="1.5" />
      {/* Bookmark ribbon tab */}
      <path d="M72 10v28l-9-7-9 7V10" stroke="#c2410c" strokeWidth="1.5" strokeLinejoin="round" />
      {/* Text lines */}
      <line x1="38" y1="56" x2="82" y2="56" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="38" y1="66" x2="75" y2="66" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="38" y1="76" x2="70" y2="76" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="38" y1="86" x2="60" y2="86" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  </Box>
);

export const EmptyBookmarksIllustration: React.FC<IllustrationProps> = ({ sx }) => (
  <Box sx={sx}>
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Open book - left page */}
      <path d="M40 20C36 16 28 14 18 14v46c10 0 18 2 22 6" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* Open book - right page */}
      <path d="M40 20c4-4 12-6 22-6v46c-10 0-18 2-22 6" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* Spine */}
      <line x1="40" y1="20" x2="40" y2="66" stroke="#c2410c" strokeWidth="1.5" />
      {/* Plus sign above */}
      <line x1="40" y1="4" x2="40" y2="12" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="36" y1="8" x2="44" y2="8" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  </Box>
);

export const EmptyQueueIllustration: React.FC<IllustrationProps> = ({ sx }) => (
  <Box sx={sx}>
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Circle */}
      <circle cx="40" cy="40" r="28" stroke="#c2410c" strokeWidth="1.5" />
      {/* Checkmark */}
      <path d="M28 40l8 8 16-16" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </Box>
);
